import { jsx as u, jsxs as V, Fragment as Ke } from "react/jsx-runtime";
import { NeuGrid as X, NeuModal as Ge, NeuAccordion as ye } from "@hcahealthcaredpx/neutron-react";
import { useSitecoreContext as rn, Text as Ze, Link as an, RichText as kt, withDatasourceCheck as sn } from "@sitecore-jss/sitecore-jss-nextjs";
import Be, { useRef as ln, useMemo as cn } from "react";
import { useI18n as un } from "next-localization";
import { u as fn } from "../../chunks/useModal.DSDGkQa1.js";
import { B as pn } from "../../chunks/button-link.BSk7JXpT.js";
import { M as mn } from "../../chunks/mho-action-buttons.fY1B40h9.js";
function Pt(o) {
  var t, r, i = "";
  if (typeof o == "string" || typeof o == "number") i += o;
  else if (typeof o == "object") if (Array.isArray(o)) {
    var l = o.length;
    for (t = 0; t < l; t++) o[t] && (r = Pt(o[t])) && (i && (i += " "), i += r);
  } else for (r in o) o[r] && (i && (i += " "), i += r);
  return i;
}
function Ne() {
  for (var o, t, r = 0, i = "", l = arguments.length; r < l; r++) (o = arguments[r]) && (t = Pt(o)) && (i && (i += " "), i += t);
  return i;
}
var be = /* @__PURE__ */ ((o) => (o.Market = "Market", o.Location = "Location", o.Practice = "Practice", o))(be || {}), Le = /* @__PURE__ */ ((o) => (o.Corporate = "Corporate", o.Hospital = "Hospital", o.Physician = "Physician", o.MHO = "MHO", o.UrgentCare = "UrgentCare", o))(Le || {});
const dn = () => {
  const { sitecoreContext: o, updateSitecoreContext: t } = rn(), r = (l) => {
    const { siteAttributes: f, ...m } = l;
    t(m);
  }, i = o;
  return i.siteAttributes = {
    isHospital: i.siteType === Le.Hospital,
    isCorporate: i.siteType === Le.Corporate,
    isMarket: i.marketContext === be.Market,
    isLocation: i.marketContext === be.Location,
    isPractice: i.marketContext === be.Practice,
    isUrgentCare: i.siteType === Le.UrgentCare
  }, {
    sitecoreContext: i,
    updateSitecoreContext: r
  };
}, _n = ({
  condition: o,
  wrapper: t,
  wrappedJSX: r
}) => o ? t(r) : r;
(function() {
  try {
    if (typeof document < "u") {
      var o = document.createElement("style");
      o.appendChild(document.createTextNode(`._playIcon_3xgwd_1{background:transparent;border:0 none;cursor:pointer;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}._playIcon_3xgwd_1 span{border-radius:50%;color:var(--neu-plain-0);font-size:78px;transition-duration:.2s;transition-property:transform;font-variation-settings:normal}._playIcon_3xgwd_1:hover i,._playIcon_3xgwd_1:focus i{transform:scale(1.3)}._opacity_3xgwd_23{opacity:.77}
._extendedDropdown_17k1l_1 .unit-dropdown .dropdown-menu{max-height:clamp(150px,80vh,500px)!important}
@media (min-width: 992px){._overlay_1tz1r_2{margin-top:-6rem}}@media (min-width: 992px){._corpOverlay_1tz1r_8{margin-top:-8rem}}._hideEmpty_1tz1r_13:has(>div:empty){display:none}
._richText_1ghed_1 a:not(._neu-button_1ghed_1){color:var(--neu-plain-0);font-size:14px;text-decoration:none}._richText_1ghed_1 a:not(._neu-button_1ghed_1):hover,._richText_1ghed_1 a:not(._neu-button_1ghed_1):focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._richText_1ghed_1 strong{font-weight:600}._richText_1ghed_1 hr{border:none;background-color:var(--neu-plain-0);height:1px;width:100%;margin:20px 0}a._corpLinks_1ghed_24{color:var(--neu-plain-0);text-decoration:none}a._corpLinks_1ghed_24:hover,a._corpLinks_1ghed_24:focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._containerFlex_1ghed_37{padding:35px}@media (min-width: 992px){._containerFlex_1ghed_37{padding:35px 72px}}
@media (min-width: 576px){._standaloneSearch_10kr5_2{min-width:20rem}}._standaloneSearch_10kr5_2 .unit-dropdown{width:100%}._standaloneSearch_10kr5_2 .neu-form--support:empty{display:none}._standaloneSearch_10kr5_2 .unit-wrapper:before{all:unset}._standaloneSearch_10kr5_2 .neu-form__native{padding:var(--form-padding);padding-right:calc(40px + var(--neu-spacer-3));min-width:18rem}._standaloneSearch_10kr5_2 .neu-form__native::-webkit-search-cancel-button{margin-top:.1rem}@media (min-width: 992px){._corporateStandalone_10kr5_25{min-width:19rem}._corporateStandalone_10kr5_25 label{color:var(--neu-plain-0)}}._standaloneSearch_10kr5_2+.input-spinner{--feedback-padding-right: calc(40px + var(--neu-spacer-3));--feedback-padding-bottom: var(--neu-spacer-3)}._standaloneButton_10kr5_37.with-label{top:calc(1.375rem + var(--neu-spacer-2))}`)), document.head.appendChild(o);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
const hn = ({
  description: o,
  title: t,
  className: r,
  headingLevel: i = "h2",
  children: l,
  hasLink: f,
  linkField: m,
  titleClassName: E = "fw-medium"
}) => {
  const O = f && m;
  return !t && !l && !o ? null : /* @__PURE__ */ V(X, { className: Ne(!O && "text-center", r), children: [
    /* @__PURE__ */ V(
      X.Row,
      {
        gutter: "none",
        className: Ne(
          "justify-content-start justify-content-lg-between align-items-start align-items-lg-end gap-3 gap-lg-0 mb-3"
        ),
        children: [
          t && /* @__PURE__ */ u(X.Column, { className: `col-12 ${O ? "col-lg-6" : ""}`, children: /* @__PURE__ */ u(Ze, { tag: i, field: t, className: E }) }),
          m && /* @__PURE__ */ u(X.Column, { className: "col-12 col-lg-6 text-lg-end", children: /* @__PURE__ */ u(an, { field: m }) })
        ]
      }
    ),
    o && /* @__PURE__ */ u(X.Row, { gutter: "none", children: /* @__PURE__ */ u(X.Column, { children: /* @__PURE__ */ u(Ze, { tag: "p", field: o }) }) }),
    l && /* @__PURE__ */ u(X.Row, { gutter: "none", children: /* @__PURE__ */ u(X.Column, { children: l }) })
  ] });
}, gn = "_overlay_1tz1r_2", Tn = "_corpOverlay_1tz1r_8", En = "_hideEmpty_1tz1r_13", Ye = {
  overlay: gn,
  corpOverlay: Tn,
  hideEmpty: En
}, An = ({
  ref: o,
  className: t,
  onClick: r,
  dataTestId: i,
  title: l,
  description: f,
  headingLevel: m,
  disableContainer: E = !1,
  overlay: O,
  children: w,
  borderToggle: q,
  variant: K,
  conditionalWrapclassName: W = "d-flex flex-column gap-5 gap-lg-7",
  titleClassName: G = "fw-medium"
}) => {
  const {
    sitecoreContext: {
      siteAttributes: { isCorporate: I }
    }
  } = dn(), v = ln(null), B = K === "white" && "neu-bg-plain-0", k = !!(l || f), Y = !(t != null && t.includes("py-")) && !E;
  return /* @__PURE__ */ u(
    "section",
    {
      ref: o,
      className: Ne(
        Y && "py-6",
        // TODO: fix hack when classnames are generated in the correct order
        q === "1" && "border-bottom border-neu-gray-20",
        B,
        "position-relative",
        Ye.hideEmpty,
        t
      ),
      "data-test-id": i,
      onClick: r,
      children: /* @__PURE__ */ u(
        _n,
        {
          condition: !E,
          wrapper: (M) => /* @__PURE__ */ u(
            "div",
            {
              className: Ne(
                "container",
                W,
                O === "1" ? I ? `${Ye.corpOverlay}` : `${Ye.overlay}` : void 0
              ),
              ref: v,
              children: M
            }
          ),
          wrappedJSX: /* @__PURE__ */ V(Ke, { children: [
            !E && k && /* @__PURE__ */ u(
              hn,
              {
                title: l,
                description: f,
                headingLevel: m,
                titleClassName: G
              }
            ),
            w
          ] })
        }
      )
    }
  );
};
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries: Ut,
  setPrototypeOf: Nt,
  isFrozen: Sn,
  getPrototypeOf: yn,
  getOwnPropertyDescriptor: bn
} = Object;
let {
  freeze: C,
  seal: x,
  create: Ft
} = Object, {
  apply: Je,
  construct: Qe
} = typeof Reflect < "u" && Reflect;
C || (C = function(t) {
  return t;
});
x || (x = function(t) {
  return t;
});
Je || (Je = function(t, r, i) {
  return t.apply(r, i);
});
Qe || (Qe = function(t, r) {
  return new t(...r);
});
const Ae = N(Array.prototype.forEach), Ln = N(Array.prototype.lastIndexOf), Rt = N(Array.prototype.pop), le = N(Array.prototype.push), Cn = N(Array.prototype.splice), Ce = N(String.prototype.toLowerCase), Xe = N(String.prototype.toString), Ot = N(String.prototype.match), ce = N(String.prototype.replace), Nn = N(String.prototype.indexOf), Rn = N(String.prototype.trim), D = N(Object.prototype.hasOwnProperty), L = N(RegExp.prototype.test), ue = On(TypeError);
function N(o) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), l = 1; l < r; l++)
      i[l - 1] = arguments[l];
    return Je(o, t, i);
  };
}
function On(o) {
  return function() {
    for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++)
      r[i] = arguments[i];
    return Qe(o, r);
  };
}
function c(o, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ce;
  Nt && Nt(o, null);
  let i = t.length;
  for (; i--; ) {
    let l = t[i];
    if (typeof l == "string") {
      const f = r(l);
      f !== l && (Sn(t) || (t[i] = f), l = f);
    }
    o[l] = !0;
  }
  return o;
}
function xn(o) {
  for (let t = 0; t < o.length; t++)
    D(o, t) || (o[t] = null);
  return o;
}
function z(o) {
  const t = Ft(null);
  for (const [r, i] of Ut(o))
    D(o, r) && (Array.isArray(i) ? t[r] = xn(i) : i && typeof i == "object" && i.constructor === Object ? t[r] = z(i) : t[r] = i);
  return t;
}
function fe(o, t) {
  for (; o !== null; ) {
    const i = bn(o, t);
    if (i) {
      if (i.get)
        return N(i.get);
      if (typeof i.value == "function")
        return N(i.value);
    }
    o = yn(o);
  }
  function r() {
    return null;
  }
  return r;
}
const xt = C(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), je = C(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), $e = C(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), wn = C(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ve = C(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Mn = C(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), wt = C(["#text"]), Mt = C(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), qe = C(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Dt = C(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Se = C(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Dn = x(/\{\{[\w\W]*|[\w\W]*\}\}/gm), In = x(/<%[\w\W]*|[\w\W]*%>/gm), vn = x(/\$\{[\w\W]*/gm), kn = x(/^data-[\-\w.\u00B7-\uFFFF]+$/), Pn = x(/^aria-[\-\w]+$/), Ht = x(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Un = x(/^(?:\w+script|data):/i), Fn = x(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), zt = x(/^html$/i), Hn = x(/^[a-z][.\w]*(-[.\w]+)+$/i);
var It = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Pn,
  ATTR_WHITESPACE: Fn,
  CUSTOM_ELEMENT: Hn,
  DATA_ATTR: kn,
  DOCTYPE_NAME: zt,
  ERB_EXPR: In,
  IS_ALLOWED_URI: Ht,
  IS_SCRIPT_OR_DATA: Un,
  MUSTACHE_EXPR: Dn,
  TMPLIT_EXPR: vn
});
const pe = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, zn = function() {
  return typeof window > "u" ? null : window;
}, Wn = function(t, r) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let i = null;
  const l = "data-tt-policy-suffix";
  r && r.hasAttribute(l) && (i = r.getAttribute(l));
  const f = "dompurify" + (i ? "#" + i : "");
  try {
    return t.createPolicy(f, {
      createHTML(m) {
        return m;
      },
      createScriptURL(m) {
        return m;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + f + " could not be created."), null;
  }
}, vt = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Wt() {
  let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : zn();
  const t = (s) => Wt(s);
  if (t.version = "3.2.6", t.removed = [], !o || !o.document || o.document.nodeType !== pe.document || !o.Element)
    return t.isSupported = !1, t;
  let {
    document: r
  } = o;
  const i = r, l = i.currentScript, {
    DocumentFragment: f,
    HTMLTemplateElement: m,
    Node: E,
    Element: O,
    NodeFilter: w,
    NamedNodeMap: q = o.NamedNodeMap || o.MozNamedAttrMap,
    HTMLFormElement: K,
    DOMParser: W,
    trustedTypes: G
  } = o, I = O.prototype, v = fe(I, "cloneNode"), B = fe(I, "remove"), k = fe(I, "nextSibling"), Y = fe(I, "childNodes"), M = fe(I, "parentNode");
  if (typeof m == "function") {
    const s = r.createElement("template");
    s.content && s.content.ownerDocument && (r = s.content.ownerDocument);
  }
  let _, j = "";
  const {
    implementation: Re,
    createNodeIterator: Gt,
    createDocumentFragment: Bt,
    getElementsByTagName: Yt
  } = r, {
    importNode: Xt
  } = i;
  let b = vt();
  t.isSupported = typeof Ut == "function" && typeof M == "function" && Re && Re.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Oe,
    ERB_EXPR: xe,
    TMPLIT_EXPR: we,
    DATA_ATTR: jt,
    ARIA_ATTR: $t,
    IS_SCRIPT_OR_DATA: Vt,
    ATTR_WHITESPACE: tt,
    CUSTOM_ELEMENT: qt
  } = It;
  let {
    IS_ALLOWED_URI: nt
  } = It, g = null;
  const ot = c({}, [...xt, ...je, ...$e, ...Ve, ...wt]);
  let A = null;
  const it = c({}, [...Mt, ...qe, ...Dt, ...Se]);
  let d = Object.seal(Ft(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ie = null, Me = null, rt = !0, De = !0, at = !1, st = !0, Z = !1, me = !0, $ = !1, Ie = !1, ve = !1, J = !1, de = !1, _e = !1, lt = !0, ct = !1;
  const Kt = "user-content-";
  let ke = !0, re = !1, Q = {}, ee = null;
  const ut = c({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ft = null;
  const pt = c({}, ["audio", "video", "img", "source", "image", "track"]);
  let Pe = null;
  const mt = c({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), he = "http://www.w3.org/1998/Math/MathML", ge = "http://www.w3.org/2000/svg", U = "http://www.w3.org/1999/xhtml";
  let te = U, Ue = !1, Fe = null;
  const Zt = c({}, [he, ge, U], Xe);
  let Te = c({}, ["mi", "mo", "mn", "ms", "mtext"]), Ee = c({}, ["annotation-xml"]);
  const Jt = c({}, ["title", "style", "font", "a", "script"]);
  let ae = null;
  const Qt = ["application/xhtml+xml", "text/html"], en = "text/html";
  let T = null, ne = null;
  const tn = r.createElement("form"), dt = function(e) {
    return e instanceof RegExp || e instanceof Function;
  }, He = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(ne && ne === e)) {
      if ((!e || typeof e != "object") && (e = {}), e = z(e), ae = // eslint-disable-next-line unicorn/prefer-includes
      Qt.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? en : e.PARSER_MEDIA_TYPE, T = ae === "application/xhtml+xml" ? Xe : Ce, g = D(e, "ALLOWED_TAGS") ? c({}, e.ALLOWED_TAGS, T) : ot, A = D(e, "ALLOWED_ATTR") ? c({}, e.ALLOWED_ATTR, T) : it, Fe = D(e, "ALLOWED_NAMESPACES") ? c({}, e.ALLOWED_NAMESPACES, Xe) : Zt, Pe = D(e, "ADD_URI_SAFE_ATTR") ? c(z(mt), e.ADD_URI_SAFE_ATTR, T) : mt, ft = D(e, "ADD_DATA_URI_TAGS") ? c(z(pt), e.ADD_DATA_URI_TAGS, T) : pt, ee = D(e, "FORBID_CONTENTS") ? c({}, e.FORBID_CONTENTS, T) : ut, ie = D(e, "FORBID_TAGS") ? c({}, e.FORBID_TAGS, T) : z({}), Me = D(e, "FORBID_ATTR") ? c({}, e.FORBID_ATTR, T) : z({}), Q = D(e, "USE_PROFILES") ? e.USE_PROFILES : !1, rt = e.ALLOW_ARIA_ATTR !== !1, De = e.ALLOW_DATA_ATTR !== !1, at = e.ALLOW_UNKNOWN_PROTOCOLS || !1, st = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Z = e.SAFE_FOR_TEMPLATES || !1, me = e.SAFE_FOR_XML !== !1, $ = e.WHOLE_DOCUMENT || !1, J = e.RETURN_DOM || !1, de = e.RETURN_DOM_FRAGMENT || !1, _e = e.RETURN_TRUSTED_TYPE || !1, ve = e.FORCE_BODY || !1, lt = e.SANITIZE_DOM !== !1, ct = e.SANITIZE_NAMED_PROPS || !1, ke = e.KEEP_CONTENT !== !1, re = e.IN_PLACE || !1, nt = e.ALLOWED_URI_REGEXP || Ht, te = e.NAMESPACE || U, Te = e.MATHML_TEXT_INTEGRATION_POINTS || Te, Ee = e.HTML_INTEGRATION_POINTS || Ee, d = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && dt(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (d.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && dt(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (d.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (d.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Z && (De = !1), de && (J = !0), Q && (g = c({}, wt), A = [], Q.html === !0 && (c(g, xt), c(A, Mt)), Q.svg === !0 && (c(g, je), c(A, qe), c(A, Se)), Q.svgFilters === !0 && (c(g, $e), c(A, qe), c(A, Se)), Q.mathMl === !0 && (c(g, Ve), c(A, Dt), c(A, Se))), e.ADD_TAGS && (g === ot && (g = z(g)), c(g, e.ADD_TAGS, T)), e.ADD_ATTR && (A === it && (A = z(A)), c(A, e.ADD_ATTR, T)), e.ADD_URI_SAFE_ATTR && c(Pe, e.ADD_URI_SAFE_ATTR, T), e.FORBID_CONTENTS && (ee === ut && (ee = z(ee)), c(ee, e.FORBID_CONTENTS, T)), ke && (g["#text"] = !0), $ && c(g, ["html", "head", "body"]), g.table && (c(g, ["tbody"]), delete ie.tbody), e.TRUSTED_TYPES_POLICY) {
        if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ue('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ue('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        _ = e.TRUSTED_TYPES_POLICY, j = _.createHTML("");
      } else
        _ === void 0 && (_ = Wn(G, l)), _ !== null && typeof j == "string" && (j = _.createHTML(""));
      C && C(e), ne = e;
    }
  }, _t = c({}, [...je, ...$e, ...wn]), ht = c({}, [...Ve, ...Mn]), nn = function(e) {
    let n = M(e);
    (!n || !n.tagName) && (n = {
      namespaceURI: te,
      tagName: "template"
    });
    const a = Ce(e.tagName), p = Ce(n.tagName);
    return Fe[e.namespaceURI] ? e.namespaceURI === ge ? n.namespaceURI === U ? a === "svg" : n.namespaceURI === he ? a === "svg" && (p === "annotation-xml" || Te[p]) : !!_t[a] : e.namespaceURI === he ? n.namespaceURI === U ? a === "math" : n.namespaceURI === ge ? a === "math" && Ee[p] : !!ht[a] : e.namespaceURI === U ? n.namespaceURI === ge && !Ee[p] || n.namespaceURI === he && !Te[p] ? !1 : !ht[a] && (Jt[a] || !_t[a]) : !!(ae === "application/xhtml+xml" && Fe[e.namespaceURI]) : !1;
  }, P = function(e) {
    le(t.removed, {
      element: e
    });
    try {
      M(e).removeChild(e);
    } catch {
      B(e);
    }
  }, oe = function(e, n) {
    try {
      le(t.removed, {
        attribute: n.getAttributeNode(e),
        from: n
      });
    } catch {
      le(t.removed, {
        attribute: null,
        from: n
      });
    }
    if (n.removeAttribute(e), e === "is")
      if (J || de)
        try {
          P(n);
        } catch {
        }
      else
        try {
          n.setAttribute(e, "");
        } catch {
        }
  }, gt = function(e) {
    let n = null, a = null;
    if (ve)
      e = "<remove></remove>" + e;
    else {
      const h = Ot(e, /^[\r\n\t ]+/);
      a = h && h[0];
    }
    ae === "application/xhtml+xml" && te === U && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
    const p = _ ? _.createHTML(e) : e;
    if (te === U)
      try {
        n = new W().parseFromString(p, ae);
      } catch {
      }
    if (!n || !n.documentElement) {
      n = Re.createDocument(te, "template", null);
      try {
        n.documentElement.innerHTML = Ue ? j : p;
      } catch {
      }
    }
    const S = n.body || n.documentElement;
    return e && a && S.insertBefore(r.createTextNode(a), S.childNodes[0] || null), te === U ? Yt.call(n, $ ? "html" : "body")[0] : $ ? n.documentElement : S;
  }, Tt = function(e) {
    return Gt.call(
      e.ownerDocument || e,
      e,
      // eslint-disable-next-line no-bitwise
      w.SHOW_ELEMENT | w.SHOW_COMMENT | w.SHOW_TEXT | w.SHOW_PROCESSING_INSTRUCTION | w.SHOW_CDATA_SECTION,
      null
    );
  }, ze = function(e) {
    return e instanceof K && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof q) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
  }, Et = function(e) {
    return typeof E == "function" && e instanceof E;
  };
  function F(s, e, n) {
    Ae(s, (a) => {
      a.call(t, e, n, ne);
    });
  }
  const At = function(e) {
    let n = null;
    if (F(b.beforeSanitizeElements, e, null), ze(e))
      return P(e), !0;
    const a = T(e.nodeName);
    if (F(b.uponSanitizeElement, e, {
      tagName: a,
      allowedTags: g
    }), me && e.hasChildNodes() && !Et(e.firstElementChild) && L(/<[/\w!]/g, e.innerHTML) && L(/<[/\w!]/g, e.textContent) || e.nodeType === pe.progressingInstruction || me && e.nodeType === pe.comment && L(/<[/\w]/g, e.data))
      return P(e), !0;
    if (!g[a] || ie[a]) {
      if (!ie[a] && yt(a) && (d.tagNameCheck instanceof RegExp && L(d.tagNameCheck, a) || d.tagNameCheck instanceof Function && d.tagNameCheck(a)))
        return !1;
      if (ke && !ee[a]) {
        const p = M(e) || e.parentNode, S = Y(e) || e.childNodes;
        if (S && p) {
          const h = S.length;
          for (let R = h - 1; R >= 0; --R) {
            const H = v(S[R], !0);
            H.__removalCount = (e.__removalCount || 0) + 1, p.insertBefore(H, k(e));
          }
        }
      }
      return P(e), !0;
    }
    return e instanceof O && !nn(e) || (a === "noscript" || a === "noembed" || a === "noframes") && L(/<\/no(script|embed|frames)/i, e.innerHTML) ? (P(e), !0) : (Z && e.nodeType === pe.text && (n = e.textContent, Ae([Oe, xe, we], (p) => {
      n = ce(n, p, " ");
    }), e.textContent !== n && (le(t.removed, {
      element: e.cloneNode()
    }), e.textContent = n)), F(b.afterSanitizeElements, e, null), !1);
  }, St = function(e, n, a) {
    if (lt && (n === "id" || n === "name") && (a in r || a in tn))
      return !1;
    if (!(De && !Me[n] && L(jt, n))) {
      if (!(rt && L($t, n))) {
        if (!A[n] || Me[n]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(yt(e) && (d.tagNameCheck instanceof RegExp && L(d.tagNameCheck, e) || d.tagNameCheck instanceof Function && d.tagNameCheck(e)) && (d.attributeNameCheck instanceof RegExp && L(d.attributeNameCheck, n) || d.attributeNameCheck instanceof Function && d.attributeNameCheck(n)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            n === "is" && d.allowCustomizedBuiltInElements && (d.tagNameCheck instanceof RegExp && L(d.tagNameCheck, a) || d.tagNameCheck instanceof Function && d.tagNameCheck(a)))
          ) return !1;
        } else if (!Pe[n]) {
          if (!L(nt, ce(a, tt, ""))) {
            if (!((n === "src" || n === "xlink:href" || n === "href") && e !== "script" && Nn(a, "data:") === 0 && ft[e])) {
              if (!(at && !L(Vt, ce(a, tt, "")))) {
                if (a)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, yt = function(e) {
    return e !== "annotation-xml" && Ot(e, qt);
  }, bt = function(e) {
    F(b.beforeSanitizeAttributes, e, null);
    const {
      attributes: n
    } = e;
    if (!n || ze(e))
      return;
    const a = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: A,
      forceKeepAttr: void 0
    };
    let p = n.length;
    for (; p--; ) {
      const S = n[p], {
        name: h,
        namespaceURI: R,
        value: H
      } = S, se = T(h), We = H;
      let y = h === "value" ? We : Rn(We);
      if (a.attrName = se, a.attrValue = y, a.keepAttr = !0, a.forceKeepAttr = void 0, F(b.uponSanitizeAttribute, e, a), y = a.attrValue, ct && (se === "id" || se === "name") && (oe(h, e), y = Kt + y), me && L(/((--!?|])>)|<\/(style|title)/i, y)) {
        oe(h, e);
        continue;
      }
      if (a.forceKeepAttr)
        continue;
      if (!a.keepAttr) {
        oe(h, e);
        continue;
      }
      if (!st && L(/\/>/i, y)) {
        oe(h, e);
        continue;
      }
      Z && Ae([Oe, xe, we], (Ct) => {
        y = ce(y, Ct, " ");
      });
      const Lt = T(e.nodeName);
      if (!St(Lt, se, y)) {
        oe(h, e);
        continue;
      }
      if (_ && typeof G == "object" && typeof G.getAttributeType == "function" && !R)
        switch (G.getAttributeType(Lt, se)) {
          case "TrustedHTML": {
            y = _.createHTML(y);
            break;
          }
          case "TrustedScriptURL": {
            y = _.createScriptURL(y);
            break;
          }
        }
      if (y !== We)
        try {
          R ? e.setAttributeNS(R, h, y) : e.setAttribute(h, y), ze(e) ? P(e) : Rt(t.removed);
        } catch {
          oe(h, e);
        }
    }
    F(b.afterSanitizeAttributes, e, null);
  }, on = function s(e) {
    let n = null;
    const a = Tt(e);
    for (F(b.beforeSanitizeShadowDOM, e, null); n = a.nextNode(); )
      F(b.uponSanitizeShadowNode, n, null), At(n), bt(n), n.content instanceof f && s(n.content);
    F(b.afterSanitizeShadowDOM, e, null);
  };
  return t.sanitize = function(s) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = null, a = null, p = null, S = null;
    if (Ue = !s, Ue && (s = "<!-->"), typeof s != "string" && !Et(s))
      if (typeof s.toString == "function") {
        if (s = s.toString(), typeof s != "string")
          throw ue("dirty is not a string, aborting");
      } else
        throw ue("toString is not a function");
    if (!t.isSupported)
      return s;
    if (Ie || He(e), t.removed = [], typeof s == "string" && (re = !1), re) {
      if (s.nodeName) {
        const H = T(s.nodeName);
        if (!g[H] || ie[H])
          throw ue("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (s instanceof E)
      n = gt("<!---->"), a = n.ownerDocument.importNode(s, !0), a.nodeType === pe.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? n = a : n.appendChild(a);
    else {
      if (!J && !Z && !$ && // eslint-disable-next-line unicorn/prefer-includes
      s.indexOf("<") === -1)
        return _ && _e ? _.createHTML(s) : s;
      if (n = gt(s), !n)
        return J ? null : _e ? j : "";
    }
    n && ve && P(n.firstChild);
    const h = Tt(re ? s : n);
    for (; p = h.nextNode(); )
      At(p), bt(p), p.content instanceof f && on(p.content);
    if (re)
      return s;
    if (J) {
      if (de)
        for (S = Bt.call(n.ownerDocument); n.firstChild; )
          S.appendChild(n.firstChild);
      else
        S = n;
      return (A.shadowroot || A.shadowrootmode) && (S = Xt.call(i, S, !0)), S;
    }
    let R = $ ? n.outerHTML : n.innerHTML;
    return $ && g["!doctype"] && n.ownerDocument && n.ownerDocument.doctype && n.ownerDocument.doctype.name && L(zt, n.ownerDocument.doctype.name) && (R = "<!DOCTYPE " + n.ownerDocument.doctype.name + `>
` + R), Z && Ae([Oe, xe, we], (H) => {
      R = ce(R, H, " ");
    }), _ && _e ? _.createHTML(R) : R;
  }, t.setConfig = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    He(s), Ie = !0;
  }, t.clearConfig = function() {
    ne = null, Ie = !1;
  }, t.isValidAttribute = function(s, e, n) {
    ne || He({});
    const a = T(s), p = T(e);
    return St(a, p, n);
  }, t.addHook = function(s, e) {
    typeof e == "function" && le(b[s], e);
  }, t.removeHook = function(s, e) {
    if (e !== void 0) {
      const n = Ln(b[s], e);
      return n === -1 ? void 0 : Cn(b[s], n, 1)[0];
    }
    return Rt(b[s]);
  }, t.removeHooks = function(s) {
    b[s] = [];
  }, t.removeAllHooks = function() {
    b = vt();
  }, t;
}
var Gn = Wt();
const Bn = /* @__PURE__ */ new Set(["area", "base", "br", "col", "embed", "hr", "img", "input"]), et = /{externalLinkModalButton.*?}}/, Yn = (o) => {
  const t = {};
  for (const { name: r, value: i } of Array.from(o.attributes))
    t[r] = i;
  return t;
}, Xn = (o) => {
  var i, l, f;
  const t = o.match(/linkText:([^;]+)/), r = o.match(/linkUrl:\s*([^;}]*)/i);
  return {
    linkText: ((i = t == null ? void 0 : t[1]) == null ? void 0 : i.trim()) ?? "",
    linkUrl: ((f = (l = r == null ? void 0 : r[1]) == null ? void 0 : l.trim()) == null ? void 0 : f.replace(/^['"]+|['"]+$/g, "")) ?? ""
  };
};
function jn({
  richText: o,
  alertTitle: t,
  alertText: r
}) {
  const { t: i } = un(), l = new DOMParser(), { isOpen: f, openModal: m, closeModal: E } = fn(), O = o.match(et), w = Gn.sanitize(o), { linkText: q, linkUrl: K } = Xn((O == null ? void 0 : O[0]) ?? ""), W = l.parseFromString(w, "text/html"), G = () => {
    window.open(K, "_blank", "noopener,noreferrer");
  }, I = (v, B) => {
    if (v.nodeType === Node.TEXT_NODE) {
      const Y = (v.textContent ?? "").split(et);
      return Y.map((M, _) => /* @__PURE__ */ V(Be.Fragment, { children: [
        M,
        _ < Y.length - 1 && /* @__PURE__ */ u(pn, { onClick: m, className: "m-0 p-0", children: q })
      ] }, `${B}-${_}`));
    }
    if (v.nodeType === Node.ELEMENT_NODE) {
      const k = v, Y = Array.from(k.childNodes).map((_, j) => I(_, j)), M = { key: B, ...Yn(k) };
      return Bn.has(k.tagName.toLowerCase()) ? Be.createElement(k.tagName.toLowerCase(), M) : Be.createElement(k.tagName.toLowerCase(), M, Y);
    }
    return null;
  };
  return /* @__PURE__ */ V(Ke, { children: [
    /* @__PURE__ */ u(Ke, { children: Array.from(W.body.childNodes).map((v, B) => I(v, B)) }),
    /* @__PURE__ */ V(Ge, { label: t, active: f, backdropDismiss: !0, onNeuDismiss: E, children: [
      /* @__PURE__ */ u(Ge.Content, { children: /* @__PURE__ */ u(kt, { field: { value: r } }) }),
      /* @__PURE__ */ u(Ge.Footer, { children: /* @__PURE__ */ u(
        mn,
        {
          primaryText: i("Mho.PageContent.RecordsLinking.Form.Labels.Continue"),
          primaryType: "button",
          onPrimaryClick: G,
          secondaryText: i("Mho.PageContent.RecordsLinking.Form.Labels.Cancel"),
          onSecondaryClick: E,
          buttonsAlignment: "end",
          wrapperClassName: "mx-3 mb-4"
        }
      ) })
    ] })
  ] });
}
const $n = ({
  fields: { headline: o, details: t },
  params: { displayExternalLinksAlert: r, alertTitle: i = "", alertText: l = "" }
}) => {
  const f = cn(() => {
    var m, E;
    return r && i && l && ((E = (m = t == null ? void 0 : t.value) == null ? void 0 : m.match(et)) == null ? void 0 : E[0]);
  }, [r, i, l, t]);
  return /* @__PURE__ */ V(ye.Item, { children: [
    /* @__PURE__ */ u(ye.Header, { children: /* @__PURE__ */ u(Ze, { field: o }) }),
    /* @__PURE__ */ u(ye.Content, { children: f ? /* @__PURE__ */ u(
      jn,
      {
        richText: (t == null ? void 0 : t.value) ?? "",
        alertTitle: i,
        alertText: l
      }
    ) : /* @__PURE__ */ u(kt, { field: t }) })
  ] });
}, Vn = (o) => {
  const {
    fields: { items: t, title: r, description: i },
    params: l = {},
    rendering: f
  } = o, {
    fullWidth: m = "",
    headingLevel: E = "",
    fontWeight: O = ""
  } = l;
  return /* @__PURE__ */ u(
    An,
    {
      title: r,
      description: i,
      disableContainer: m === "1",
      variant: "white",
      headingLevel: E || "h4",
      titleClassName: O || "fw-regular",
      dataTestId: f == null ? void 0 : f.componentName,
      children: t && /* @__PURE__ */ u(ye, { children: t == null ? void 0 : t.map((W) => /* @__PURE__ */ u($n, { ...W, params: l }, W.fields.id)) })
    }
  );
}, oo = sn()(
  Vn
);
export {
  oo as MhoAccordionBlock
};
